import React from 'react';
import SimpleTable from '../../teal-react/components/organisms/SimpleTable';
import { useUsersQuery } from '../../graphql/queries';
import Loading from '../../teal-react/components/molecules/Loading';
import SimpleModal from '../../teal-react/components/organisms/SimpleModal';
import SimpleForm from '../../teal-react/components/organisms/SimpleForm';
import { useSave } from '../../graphql/hooks';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonIcon from '@mui/icons-material/Person';
import { Add, Password } from '@mui/icons-material';
import SimpleDeleteConfirm from '../../teal-react/components/organisms/SimpleDeleteConfirm';

const Users = () => {
  const { data } = useUsersQuery();
  const [user, setUser] = React.useState<any>();
  const [userPwdUpdate, setUserPwdUpdate] = React.useState(0);
  const saveUser = useSave('user', 'user');

  if (!data) {
    return <Loading />;
  }
  return (
    <>
      <SimpleTable
        header="Users"
        data={data.user}
        headeraction={{
          icon: <Add />,
          onClick: () => {
            setUser({ firstname: '', lastname: '', role: 'User' });
          },
        }}
        columns={[
          {
            header: 'First',
            cell: 'firstname',
          },
          {
            header: 'Last',
            cell: 'lastname',
          },
          {
            header: 'Email',
          },
          {
            header: 'Role',
          },
          {
            header: 'Status',
            cell: (r: any) => (r.enabled ? 'Enabled' : 'Disabled'),
          },
          {
            header: 'Actions',
            sort: false,
            cell: (r: any) => {
              return (
                <>
                  <IconButton onClick={() => setUser(r)} title="Edit User">
                    <EditIcon color="info" />
                  </IconButton>
                  {r.enabled ? (
                    <>
                      <IconButton
                        title="User is enabled, click to disable"
                        onClick={() => saveUser({ id: r.id, enabled: 0 })}
                      >
                        <PersonIcon color="success" />
                      </IconButton>
                      <IconButton
                        onClick={() => setUserPwdUpdate(r.id)}
                        title="Reset Password"
                      >
                        <Password color="warning" />
                      </IconButton>
                    </>
                  ) : (
                    <IconButton
                      title="User is disabled, click to re-enable"
                      onClick={() => saveUser({ id: r.id, enabled: 1 })}
                    >
                      <PersonOffIcon color="error" />
                    </IconButton>
                  )}
                </>
              );
            },
          },
        ]}
      />
      {userPwdUpdate ? (
        <SimpleDeleteConfirm
          header="Reset Password?"
          confirm="Reset"
          message="Users password will be reset to system default."
          onCancel={() => setUserPwdUpdate(0)}
          onDelete={() => {
            saveUser({ id: userPwdUpdate, password: 'PASSWORD_RESET' });
            setUserPwdUpdate(0);
          }}
        />
      ) : null}

      {user ? (
        <SimpleModal
          open={Boolean(user)}
          onClose={() => setUser(undefined)}
          size="md"
        >
          <SimpleForm
            header={`${user?.firstname ? 'Edit:' : 'Add User'} ${
              user?.firstname
            } ${user?.lastname}`}
            model={user}
            cancel={() => setUser(undefined)}
            save={({ modified }: { modified: any }) => {
              saveUser({ id: user?.id, ...modified }, !Boolean(user?.id));
              setUser(undefined);
            }}
            fields={[
              {
                name: 'firstname',
                label: 'First Name',
                validate: { required: true },
                size: 6,
              },
              {
                name: 'lastname',
                label: 'Last Name',
                validate: { required: true },
                size: 6,
              },
              {
                name: 'email',
                label: 'Email',
                validate: { required: true, email: true },
                size: 6,
              },
              {
                name: 'role',
                label: 'Role',
                options: [
                  {
                    value: 'User',
                    label: 'User',
                  },
                  {
                    value: 'Admin',
                    label: 'Admin',
                  },
                  {
                    value: 'Read-Only',
                    label: 'Read-Only',
                  },
                ],
                size: 6,
              },
            ]}
          />
        </SimpleModal>
      ) : null}
    </>
  );
};

export default Users;
